<template>
    <div class="tab-pane fade show active" id="barcodes" role="tabpanel" aria-labelledby="barcodes-tab">
        <transition name="vue-table-loader">
            <div class="vue-details-loader alt" v-if="loading"><span class="fa fa-cog fa-spin fa-1x"></span></div>
        </transition>
        <div class="product-form-tab">
            <div class="row">
                <div class="col-md-6 clearfix">
                    <h3 class="pt-2 mb-2">Barcodes</h3>
                </div>
                <div class="col-md-6 text-right" v-if="$parent.permissionAllowed('manage_products')">
                    <button class="btn btn-primary text-right mb-2" data-toggle="collapse" data-target="#create_barcode">Create Barcode</button>
                </div>
            </div>
            <div id="create_barcode" class="collapse border p-4 mb-1" v-if="$parent.permissionAllowed('manage_products')">
                <input-loader :fields="productBarcodes.items.groupItems"></input-loader>
                <div class="form-group row">
                    <div class="col-md-12 text-right">
                        <button type="submit" class="btn btn-primary" @click="createProductBarcode()">Create</button>
                        <button type="button" class="btn btn-secondary" data-toggle="collapse" data-target="#create_barcode">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
            <div class="dataTables_wrapper container-fluid dt-bootstrap4 mt-2">
                <vuetable ref="vuetable"
                    :api-url="grid"
                    :fields="fields"
                    :css="css.table"
                    noDataTemplate="No Barcodes Found"
                    @vuetable:loaded="onLoaded"
                    pagination-path=""
                    :per-page="perPage"
                    :append-params="moreParams"
                    @vuetable:pagination-data="onPaginationData"
                >
                    <template slot="options" slot-scope="props" v-if="$parent.permissionAllowed('manage_products')">
                        <div class="text-right">
                            <div class="dropdown channel-tool-menu text-right mb-1">
                                <button type="button" class="btn btn-outline-primary " data-toggle="dropdown">
                                    <i class="fa fa-cog" aria-hidden="true"></i>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right" id="batch_operation">
                                    <a  @click="loadEditBarcodeForm(props.rowData)" data-toggle="modal" data-target="#editBarcodeModal" class="dropdown-item">
                                        <span>Edit</span>
                                    </a>
                                    <a class="dropdown-item" @click="deleteProductBarcode(props.rowData.id)">
                                        <span>Delete</span>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <!-- {{props.rowData.id}} -->
                    </template>
                </vuetable>
                <div class="row">
                    <div class="col-md-6">
                        <base-pagination-info
                            :css="css.table"
                            ref="paginationInfo"
                        >
                        </base-pagination-info>
                    </div>
                    <div class="col-md-6">
                        <base-pagination  ref="pagination"
                        @vuetable-pagination:change-page="onChangePage"
                        ></base-pagination>
                    </div>
                </div>
            </div>
            <transition name="vue-table-loader">
                <div class="messaging" v-if="message">{{message}}</div>
            </transition>
        </div>
        <!-- Modal -->
        <div class="modal fade" id="editBarcodeModal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Edit Barcode</h5>
                    </div>
                    <div class="modal-body">
                        <input-loader :fields="productBarcodes.items.groupItems"></input-loader>
                        <div class="row">
                            <div class="col-md-12 text-right">
                                <button type="button" class="btn btn-secondary" @click="cancelEditBarcode()">Close</button>
                                <button type="button" class="btn btn-primary" @click="updateProductBarcode()">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End Modal -->
    </div>
</template>
<script>
var base_url = window.location.protocol + "//" + window.location.host

import axios from 'axios'
import _ from "lodash";
import moment from 'moment';
import * as Vuetable from 'vuetable-2';
import BasePagination from '../tables/base-pagination.vue';
import BasePaginationInfo from '../tables/base-pagination-info.vue';
import InputLoader from '../form/form-loader.vue';

export default {
    name: 'barcodes',
    components:{
        'input-loader': InputLoader,
        'base-pagination': BasePagination,
        'base-pagination-info': BasePaginationInfo,
    },
    data() {
        return {
            perPage: 10,
            loading: true,
            moreParams: {},
            message: "",
            uiStates: {
                errorMessage: true,
                showLoading: true
            },
            grid: base_url + '/pimapi/products/' + this.$parent.product.info.id + '/barcodes',
            fields: [
                {
                    name: 'barcode',
                },
                {
                    name: 'type',
                },
                {
                   name: '__slot:options',
                   title: ''
                }
            ],
            css: {
                table: {
                    tableClass: 'table table-middle table-minimal',
                    ascendingIcon: 'sort-icon-asc',
                    descendingIcon: 'sort-icon-desc',
                    infoClass: '',
                },
            },
            calendarButtonIcon: 'fa fa-calendar',
            inputClass: 'form-control',
            productBarcodes: {
                items: {
                    groupingName: 'Barcodes',
                    groupItems: [
                        {
                            "name": "barcode",
                            "label": "Barcode",
                            "required": true,
                            "type": "text",
                            "column": "col-md-6",
                            "value": "",
                            "options": []
                        },
                        {
                            "name": "type",
                            "label": "Type",
                            "required": true,
                            "type": "select",
                            "column": "col-md-6",
                            "value": "",
                            "options": [
                                {
                                    "id": "UPC-A",
                                    "name": "UPC-A",
                                    "selected": false
                                },
                                {
                                    "id": "EAN",
                                    "name": "EAN",
                                    "selected": false
                                },
                                {
                                    "id": "ITF-14",
                                    "name": "ITF-14",
                                    "selected": false
                                },
                                {
                                    "id": "GTIN-13",
                                    "name": "GTIN-13",
                                    "selected": false
                                },
                                {
                                    "id": "Custom",
                                    "name": "Custom",
                                    "selected": false
                                },
                            ]
                        },
                    ]
                }
            },
            editBarcodeId: null
        }
    },
    methods : {
        customFormatter(date) {
            return moment(date).format('YYYY-MM-DD');
        },
        formatDate(value) {
            if(value === null) {
                return 'Never';
            }
            return moment(value).format('MMM Do YYYY');
        },
        onLoaded: function() {
            this.loading = false;
        },
        createProductBarcode() {
            axios.post(base_url + '/pimapi/products/' + this.$parent.product.info.id + '/barcodes', {
                'ProductBarcodes' : this.productBarcodes
            })
            .then(function(response) {
                this.$refs.vuetable.reload();
                this.clearFormData();
                this.collapseForm();
                this.$parent.alert.status = "alert-success";
                this.$parent.alert.message = 'A new product barcode has been added'
            }.bind(this))
            .catch(function(error) {
                console.log(error);
                this.$parent.alert.status = "alert-danger";
                this.$parent.alert.message = error.response.data.message;
            }.bind(this))
        },
        loadEditBarcodeForm(barcode) {
            this.collapseForm();
            this.editBarcodeId = barcode.id;
            this.productBarcodes.items.groupItems[0].value = barcode.barcode;
            this.productBarcodes.items.groupItems[1].value = barcode.type;

        },
        cancelEditBarcode() {
            this.editBarcodeId = null;
            this.clearFormData();
            $('#editBarcodeModal').modal('hide');

        },
        updateProductBarcode() {
            axios.put(base_url + '/pimapi/products/' + this.$parent.product.info.id + '/barcodes/' + this.editBarcodeId, {
                'ProductBarcodes' : this.productBarcodes
            })
            .then(function(response) {
                this.$refs.vuetable.reload();
                this.$parent.alert.status = "alert-success";
                this.$parent.alert.message = 'The product barcode (id: ' + this.editBarcodeId + ') has been updated';
                this.clearFormData();
                $('#editBarcodeModal').modal('hide');
            }.bind(this))
            .catch(function(error) {
                this.$parent.alert.status = "alert-danger";
                this.$parent.alert.message = error.response.data.message;
            }.bind(this))

        },
        deleteProductBarcode(id){
            axios.delete(base_url + '/pimapi/products/' + this.$parent.product.info.id + '/barcodes/' + id, {

            })
            .then(function(reponse) {
                this.$refs.vuetable.reload();
                this.$parent.alert.status = "alert-success";
                this.$parent.alert.message = 'The product barcode (id: ' + id + ') has been removed';
            }.bind(this))
            .catch(function(error) {
                this.$parent.alert.status = "alert-danger";
                this.$parent.alert.message = error.response.data.message;
            }.bind(this))
        },
        clearFormData() {
            this.productBarcodes.items.groupItems.map(x => x.value = "");
        },
        collapseForm: function() {
            $('#create_barcode').collapse('hide');
        },
        convertToKebabCase(str) {
            if (str == null) {
                return;
            }
            return str.replace(/\s+/g, '-').toLowerCase();
        },
        onChangePage (page) {
            this.$refs.vuetable.changePage(page)
        },
        onPaginationData (paginationData) {
            this.$refs.pagination.setPaginationData(paginationData)
            this.$refs.paginationInfo.setPaginationData(paginationData)
        },
    },
}
</script>

<style lang="scss" scoped>
    .channel-tool-menu{
        display: inline;
        .btn{
            margin-top: -1px;
            width: 26px;
            height: 26px;
            padding: 0 0;
            border-color: #ADADAD;
            color: #686868;
        }
    }
    .messaging{
        color: #566670;
        position: absolute;
        bottom: 2px;
        right: 5px;
        font-size: 9px;

    }
</style>
